import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.05,
    boxShadow: '0px 0px 24px rgba(242, 183, 5, 0.4)'
  }} whileTap={{
    scale: 0.95
  }} className={`inline-block bg-gold text-carbon font-bold py-4 px-8 rounded-md text-center transition-colors ${className}`} data-id="element-61">
      {children}
    </motion.a>;
}